<div class="box box-white has-shadow">
    <div class="box-header box-body">

        <div class="box-header-icon">
            <i class="icon-customer"></i>
        </div>

        <div class="box-header-title">
            {{ 'OFFER_CONFIG.CLIENTS' | translate }}
        </div>
    </div>

    <div class="box-content">
        <div class="box-body">
            <div class="box-row has-padding has-bottom-border" *ngFor="let person of partyList"
                 [class.has-bottom-border]="partyList.length > 1">
                <div class="box-item">
                    <div class="row">
                        <div class="col-3">
                            <app-output [label]="personLabel(person) | translate">
                                {{ person.fullName }}
                            </app-output>
                        </div>
                        <div class="col-2">
                            <app-output [label]="'LABEL.PESEL' | translate">
                                {{ person.pesel }}
                            </app-output>
                        </div>
                        <div [class.col-3]="person.otherCorrespondenceAddress"
                             [class.col]="!person.otherCorrespondenceAddress">
                            <app-output [label]="personAddressLabel(person) | translate">
                                {{ person.mainAddress.fullAddress }}
                            </app-output>
                        </div>
                        <div class="col-4" *ngIf="person.otherCorrespondenceAddress">
                            <app-output [label]="'LABEL.ADDRESS_CORESPONDENCE' | translate">
                                {{ person.correspondenceAddress.fullAddress }}
                            </app-output>
                        </div>
                    </div>
                </div>

                <div class="box-item box-item-action align-self-center justify-content-end" *ngIf="!readonly">
                    <div class="col-auto">
                        <button class="btn btn-link btn-slim"
                                (click)="delete(person)"
                                [matTooltip]="'TOOLTIP.DELETE_INSURED' | translate"
                                *ngIf="policyholderId !== person.id">
                            <i class="icon-delete mr-1"></i>
                        </button>
                        <button class="btn btn-link btn-slim"
                                [matTooltip]="(policyholderId === person.id ? 'TOOLTIP.EDIT_POLICYHOLDER' : 'TOOLTIP.EDIT_INSURED') | translate"
                                (click)="edit(person)">
                            <i class="icon-edit"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="box-row" *ngIf="numberOfInsured < 3 && !readonly">
                <div class="box-item text-accent">
                    <button class="btn btn-link btn-slim" type="button" (click)="addInsured()">
                        <i class="icon-add mr-2"></i>
                        <span>{{'BUTTON.ADD_INSURED' | translate}}</span></button>
                </div>
            </div>
        </div>
    </div>
</div>
